<script lang="ts" setup>
import { useModal } from '@/composables/useModal'

const { modalQueue } = useModal()
</script>
<template>
  <component
    v-for="modal in modalQueue"
    :is="modal.component"
    v-bind="modal.props"
    :key="modal.id"
  />
</template>
